import { createTheme, ThemeOptions } from "@mui/material";

const lightTheme: ThemeOptions = createTheme({
  palette: {
    primary: {
      main: "#323447",
    },
    info: {
      main: "#fff",
    },
  },
});

export default lightTheme;
